/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeDocumentVersionWithRelations } from './normativeDocumentVersionWithRelations';
import { NormativeDocumentWithRelations } from './normativeDocumentWithRelations';


export interface NormativeDocumentControllerDetail200ResponseData { 
    document?: NormativeDocumentWithRelations;
    currentVersion?: NormativeDocumentVersionWithRelations;
    versions?: Array<NormativeDocumentVersionWithRelations>;
    /**
     * El documento pide contraseña. El hash nunca sale en la respuesta
     */
    hasPassword?: boolean;
}

